module.exports = __webpack_public_path__ + "img/send-email-token.ee18b415.svg";